export default __webpack_public_path__ + "graphics/vogue.281e3665.svg";